import { useTiVoDeviceData } from "components/form/fields/TiVoTargets";
import { Section } from "components/layout";

import { PublicationStatus } from "../../PublicationsList";
import { VariantPublicationTable } from "../components";
import { PublicationsSubTabProps } from "../types";

export function TiVoAppDetailsPublicationsSummarySubTab({
  publication,
  platforms,
}: PublicationsSubTabProps) {
  const deviceData = useTiVoDeviceData();
  return publication.platforms.map((platform) => {
    const withClientTypes = platforms.find(
      ({ id }) => id === platform.platformId
    )?.targetedByClientType;

    return (
      <Section key={platform.platformId} header={platform.platformName}>
        <VariantPublicationTable
          platformId={platform.platformId}
          publication={publication}
        >
          {({
            variantReleaseStages,
            oemPublication,
            applicableReleaseStages,
            oemId,
            clientTypeId,
            releaseStage,
          }) => {
            const oemPublicationByStage = oemPublication[releaseStage];
            const isPublished =
              oemPublicationByStage &&
              (!withClientTypes ||
                oemPublicationByStage.length === 0 ||
                (clientTypeId && oemPublicationByStage.includes(clientTypeId)));

            const targets = (publication.variant?.versions || []).find(
              (version) => version.releaseStages?.includes(releaseStage)
            )?.targets;

            const isTargetValid =
              clientTypeId && withClientTypes
                ? deviceData
                    .getClientTypeIds([platform.platformId], [oemId], targets)
                    .includes(clientTypeId)
                : deviceData
                    .getOemIds([platform.platformId], targets)
                    .includes(oemId);

            return (
              <PublicationStatus
                publication={isPublished ? [releaseStage] : []}
                releaseStage={releaseStage}
                variantReleaseStages={variantReleaseStages}
                applicableReleaseStages={applicableReleaseStages}
                isTargetValid={isTargetValid}
              />
            );
          }}
        </VariantPublicationTable>
      </Section>
    );
  });
}
